module.exports = __webpack_public_path__ + "img/pythonbox1pic2.9243aab2.png";